export const ROLE_PERMISSIONS = {
  "OA==": { // PS
    canView: true,
    canAdd: false,
    canEdit: false,
    canApprove: true,
    canReject: true,
    sidebar: ["DriverList","Logout","Home"], // only DriverList
  },
  "Nw==": { // School
    canView: true,
    canAdd: true,
    canEdit: true,
    canApprove: false,
    canReject: false,
    sidebar: ["DriverList", "AddDriver","Logout"], 
  },
  "OQ==": { // RTO
    canView: true,
    canAdd: false,
    canEdit: false,
    canApprove: false,
    canReject: false,
    sidebar: ["DriverList","Logout"],
  },
  "Mg==": { // Admin
    canView: true,
    canAdd: true,
    canEdit: true,
    canApprove: true,
    canReject: true,
    sidebar: ["DriverList", "AddDriver", "Settings","Logout"],
  },
};
